// *** import {Config, CognitoIdentityCredentials} from "aws-sdk";
import {
  CognitoUserPool,
  CognitoUserAttribute
// ***  CognitoUser,
// ***  AuthenticationDetails
} from "amazon-cognito-identity-js";
import React from 'react';
// *** import { handleErrorFunc } from '../App';

import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';

import appConfig from '../appConfig';

/***************
Config.region = appConfig.region;
Config.credentials = new CognitoIdentityCredentials({
  IdentityPoolId: appConfig.IdentityPoolId
});
****************/

const userPool = new CognitoUserPool({
  UserPoolId: appConfig.UserPoolId,
  ClientId: appConfig.ClientId,
});




export default class RegisterView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      username: "",
      password: ""
    };
  }


  handleEmailChange(e) {
    this.setState({email: e.target.value});
  }

  handleNameChange(e) {
    this.setState({username: e.target.value});
  }

  handlePasswordChange(e) {
    this.setState({password: e.target.value});
  }

  handleSubmit(e) {
    e.preventDefault();
    const email = this.state.email.trim();
    const username = this.state.username.trim();
    const password = this.state.password.trim();
    const attributeList = [
      new CognitoUserAttribute({
        Name: 'email',
        Value: email,
      }),
      new CognitoUserAttribute({
        Name: 'name',
        Value: username,
      })
    ];
    userPool.signUp(email, password, attributeList, null, (err, result) => {
      if (err) {
        console.log(err);
        return;
      }
      console.log('user name is ' + result.user.getUsername());
      console.log('call result: ' + result);
      this.setState({email: ""});
      this.setState({username: ""});
      this.setState({password: ""});
    });
  }

  render () {
    const style = {
      width: '80%',
      margin: 50,
      padding: 50,
      display: 'inline-block',
    };
    return (
      <div>
        <Paper style={style} zDepth={1}>
          <h2 style={{textAlign: 'left'}}>ユーザ登録</h2>
          <form onSubmit={this.handleSubmit.bind(this)}>
            <TextField fullWidth={true}
                 value={this.state.email}
                 hintText="Email"
                 onChange={this.handleEmailChange.bind(this)}/><br />
            <TextField fullWidth={true}
                 value={this.state.username}
                 hintText="名前（表示名、お好きなもの）"
                 onChange={this.handleNameChange.bind(this)}/><br />
            <TextField fullWidth={true}
                 value={this.state.password}
                 hintText="パスワード（英数字で8文字以上。大文字と小文字、数字を必ず混ぜてください。）"
                 onChange={this.handlePasswordChange.bind(this)}/><br />
            <input type="submit"/>
          </form>
          <br /><br />
          <div>
              送信ボタンを押すとメール宛に検証リンクを送りますので、クリックしてからログインしてください。
          </div>
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/RegisterView.js